import React from 'react';
const PartnerTiresCard = ({tiersInfo}) => {
    return (
        <div className="col-md-4">
            <div className="partner-tires-card">
                <div>
                    <img src={tiersInfo?.img?.url} className="img-fluid" alt="" />
                </div>
                <h5 className="mt-2 pb-2">{tiersInfo?.title1}</h5>
                <ul className="ps-4">
           
                 
                    {tiersInfo?.features1 && <li>  {tiersInfo?.features1}</li>}
                    {tiersInfo?.features2 && <li>  {tiersInfo?.features2}</li>}
                    {tiersInfo?.features3 && <li>  {tiersInfo?.features3}</li>}
                    {tiersInfo?.features4 && <li>  {tiersInfo?.features4}</li>}
            


                </ul>
            </div>

        </div>
    );
};

export default PartnerTiresCard;